module.exports = __webpack_public_path__ + "static/logo-6ee48520b32790d42546e3c49874e3fc.png";